import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import BasicPicker from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import useEquipmentChecklists from 'containers/equipment-inspections/hooks/useEquipmentChecklists';
import useOnMount from 'hooks/utils/useOnMount/useOnMount';
import { t } from 'i18next';
import { useState } from 'react';
import { ClassName } from 'types/ClassName';

export interface IEquipmentInspectionChecklistPickerProps {
  className?: ClassName;
  value: string | null;
  onSelect: (value: string | null) => void;
}

const EquipmentInspectionChecklistPicker = (props: IEquipmentInspectionChecklistPickerProps) => {
  const { className, value, onSelect } = props;

  const { getEquipmentChecklists } = useEquipmentChecklists();

  const [data, setData] = useState<{ id: string; name: string }[]>([]);

  useOnMount(() => {
    getData();
  });

  const getData = async () => {
    const checklists = await getEquipmentChecklists();

    const pickerData = checklists.map((item) => ({
      id: item.id,
      name: item.checklistTitle,
    }));

    setData(pickerData);
  };

  const classes = classNames('equipment-inspection-checklist-picker', className);

  return <BasicPicker value={value} placeholder={t('Checklist')} onSelect={onSelect} data={data} className={classes} />;
};

export default EquipmentInspectionChecklistPicker;
